"use client";

import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const SHOWCASE_COLUMN_1 = [
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_1.png?alt=media&token=330a8ff4-c3f8-4af8-aab7-825b90736f54",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_2.png?alt=media&token=67342521-033c-42cc-ae55-2900570804a4",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_3.png?alt=media&token=60dddf1d-64b3-48c2-9ec8-b4c1571897aa",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_4.png?alt=media&token=759e652e-d861-4b28-b3ad-ad509bd02b10",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_2A.png?alt=media&token=b1cc11d5-d14b-4f51-90cd-697ced86b4b5",
];

const SHOWCASE_COLUMN_2 = [
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_1A.png?alt=media&token=17d64bca-77ff-4c77-beea-433a11f2ff68",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_2A.png?alt=media&token=b1cc11d5-d14b-4f51-90cd-697ced86b4b5",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_3A.png?alt=media&token=49d53eab-b0aa-453c-b50b-f9fea6b3b830",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_4B.png?alt=media&token=5e228eda-5f83-4f07-af1c-afca3c53058c",
];

const SHOWCASE_COLUMN_3 = [
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_1B.png?alt=media&token=fb3199c1-ea6c-4688-9f82-5583d1354399",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_2B.png?alt=media&token=e81bd5af-1dd2-44d6-8cfd-968fbc9a378f",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_3B.png?alt=media&token=a967ddf5-8550-476d-9bdc-62dc8488792a",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%2Fsign_up_showcase_1.png?alt=media&token=330a8ff4-c3f8-4af8-aab7-825b90736f54",
];

// Variant B assets — zoomed out layout
const SHOWCASE_COLUMN_1_B = [
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fassignment_get_feedback-1.png?alt=media&token=918cf49d-bfa6-4ade-b79a-7e8f5dfd5a54",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fassignment_outline-1.png?alt=media&token=3472c7de-2f93-43c2-aa97-5861bb7a2ec1",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fassignments_brainstorm.png?alt=media&token=9e586daa-92ee-4e6f-b8e1-7155671ff19c",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fexams_flashcards.png?alt=media&token=ac4b4520-922a-4b14-98a2-1be02c718bb8",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fexams_mind_map-1.png?alt=media&token=7a3753c2-020e-4069-9559-0dea3a786b3f",
];

const SHOWCASE_COLUMN_2_B = [
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fexams_mind_map.png?alt=media&token=834560bd-b65d-48ee-85ab-0b4ff84ccab8",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fexams_study_guide-1.png?alt=media&token=2f749fe0-a8eb-44da-a99c-e2a076db2426",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fexams_study_guide-2.png?alt=media&token=f6f95694-7e57-494b-9046-ab9d3fb19da1",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fexams_study_guide.png?alt=media&token=9b2ad79f-982e-430e-8380-80d8c8a081ca",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Flectures_flashcards.png?alt=media&token=f8e3b8f9-3ca8-467e-8b88-3bb3be34df1e",
];

const SHOWCASE_COLUMN_3_B = [
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Flectures_visualized_summary-1.png?alt=media&token=b582a80f-afb9-4a3c-aafe-2c750349f041",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Flectures_visualized_summary-2.png?alt=media&token=81bda104-12f5-4e58-b538-59c9ba2cc1cd",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Flectures_visualized_summary.png?alt=media&token=9b64afe1-e612-43e1-a017-9f03f1b60147",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fmock_exam-1.png?alt=media&token=1b462fc4-97d4-4595-9783-77e671d5b8e4",
  "https://firebasestorage.googleapis.com/v0/b/medly-540f4.appspot.com/o/assets%2Fopen%2Fsign%20up%20showcase%2Fsign%20up%20showcase%20v2%20B%2Fmock_exam.png?alt=media&token=5276c125-71f5-4643-bb4b-034710838ed4",
];

// Variant B column 4 — mix from other columns for extra-wide screens
const SHOWCASE_COLUMN_4_B = [
  SHOWCASE_COLUMN_2_B[1],
  SHOWCASE_COLUMN_3_B[2],
  SHOWCASE_COLUMN_1_B[3],
  SHOWCASE_COLUMN_2_B[4],
  SHOWCASE_COLUMN_3_B[0],
];

const SIGNUP_GALLERY_VARIANT_FLAG = "signup-gallery-variant";

function ShowcaseColumn({
  images,
  columnIndex,
  columnWidth,
  repeats = 2,
  extraClassName,
}: {
  images: string[];
  columnIndex: number;
  columnWidth: string;
  repeats?: number;
  extraClassName?: string;
}) {
  return (
    <div
      className={`${columnWidth} shrink-0 flex flex-col gap-4 ${extraClassName ?? ""}`}
    >
      {Array.from({ length: repeats }, (_, setIndex) =>
        images.map((src, i) => (
          <img
            key={`col${columnIndex}-${setIndex}-${i}`}
            src={src}
            alt="Medly Open document showcase"
            loading="lazy"
            className="w-full h-auto rounded-xl"
          />
        )),
      )}
    </div>
  );
}

export default function ShowcaseGallery() {
  const searchParams = useSearchParams();
  const [isZoomedOut, setIsZoomedOut] = useState(false);

  useEffect(() => {
    // Query param override for local testing: ?gallery=b
    const galleryParam = searchParams.get("gallery");
    if (galleryParam === "b") {
      setIsZoomedOut(true);
      return;
    }
    if (galleryParam === "a") {
      setIsZoomedOut(false);
      return;
    }

    // Wait for PostHog to be ready, then read the feature flag.
    // The SDK loads async via a <Script> tag, so it may not be
    // available on first render.
    const check = () => {
      const ph = (window as any).posthog;
      if (!ph?.getFeatureFlag) return false;
      const value = ph.getFeatureFlag(SIGNUP_GALLERY_VARIANT_FLAG);
      if (value !== undefined) {
        setIsZoomedOut(value === "test");
        return true;
      }
      return false;
    };

    // Try immediately in case PostHog is already loaded
    if (check()) return;

    // Register callback for when flags arrive
    const ph = (window as any).posthog;
    if (ph?.onFeatureFlags) {
      ph.onFeatureFlags(check);
      return;
    }

    // PostHog stub not yet on window — poll until it appears
    const interval = setInterval(() => {
      const ph = (window as any).posthog;
      if (ph?.onFeatureFlags) {
        clearInterval(interval);
        if (!check()) {
          ph.onFeatureFlags(check);
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [searchParams]);

  const columnWidth = isZoomedOut ? "w-[280px]" : "w-[380px]";
  const thirdColumnBreakpoint = isZoomedOut ? "xl:flex" : "2xl:flex";
  const repeats = isZoomedOut ? 4 : 2;

  const col1 = isZoomedOut ? SHOWCASE_COLUMN_1_B : SHOWCASE_COLUMN_1;
  const col2 = isZoomedOut ? SHOWCASE_COLUMN_2_B : SHOWCASE_COLUMN_2;
  const col3 = isZoomedOut ? SHOWCASE_COLUMN_3_B : SHOWCASE_COLUMN_3;

  return (
    <div className="hidden lg:block fixed top-0 right-0 w-[56%] h-screen overflow-hidden">
      <div className="absolute -top-[30%] -left-[5%] -right-[50%] -bottom-[30%] overflow-hidden">
        <div className="animate-showcase-scroll origin-top-left flex gap-4 p-4">
          <ShowcaseColumn
            images={col1}
            columnIndex={1}
            columnWidth={columnWidth}
            repeats={repeats}
          />
          <ShowcaseColumn
            images={col2}
            columnIndex={2}
            columnWidth={columnWidth}
            repeats={repeats}
          />
          <ShowcaseColumn
            images={col3}
            columnIndex={3}
            columnWidth={columnWidth}
            repeats={repeats}
            extraClassName={`hidden ${thirdColumnBreakpoint}`}
          />
          {isZoomedOut && (
            <ShowcaseColumn
              images={SHOWCASE_COLUMN_4_B}
              columnIndex={4}
              columnWidth={columnWidth}
              repeats={repeats}
              extraClassName="hidden 2xl:flex"
            />
          )}
        </div>
      </div>
    </div>
  );
}
